import React, { useEffect } from 'react';

import { di } from 'react-magnetic-di';

import { AggErrorPage } from './common/ui/agg-error-page/AggErrorPage';
import { redirectToLogin } from './common/utils/redirect-utils';

type SentryErrorBoundaryProps = {
	error: {
		message: string;
	};
};

export const WrappedAppSentryErrorFallback = ({
	error,
	...otherProps
}: SentryErrorBoundaryProps): React.JSX.Element | null => {
	di(AggErrorPage, redirectToLogin);
	const shouldRedirectToLogin = error.message.includes(
		"Relay: Missing @required value at path 'me.user' in 'AppSelectorQuery'",
	);

	useEffect(() => {
		if (shouldRedirectToLogin) {
			redirectToLogin();
		}
	}, [shouldRedirectToLogin]);

	// Check if the AppSelectorQuery is missing the user value:
	// (if so, redirect user to the login page - they just need to login again)
	if (shouldRedirectToLogin) {
		return null;
	}

	// Otherwise render a generic error message:
	// (this help's us avoid redirection bombing the atlassian login page)
	return <AggErrorPage error={error} {...otherProps} />;
};
